import React, { useState, useEffect, useContext } from 'react';
import logo from '../assets/images/cards/Chinmaya-Mission-Logo.gif';
import donation from '../assets/images/cards/GuruDakshina.jpg'
//import chykcon from '../assets/images/cards/Chykcon.jpg'
import { Grid, Typography, Paper, Box } from '@mui/material';
import FormCard from '../components/FormCard';
import UserList from '../components/FetchEvents';
import { DataContext } from '../App';
import HeaderBar from '../components/HeaderBar/HeaderBar';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { Token } from '@mui/icons-material';
import { useMember } from '../context/MemberProfileContext';
import { fetchEventTypes } from '../api/memberServices';
import { useLocation } from 'react-router-dom';
const drawerWidth = 240;


export default function EventTypesForm() {
  console.log("Entry EventTypes form :");
  const { accessToken, signOut } = useAuth();
  console.log("Token value", accessToken);
  const { memberProfile, setMemberProfile, setPersonName, eventTypes, setEventTypes } = useMember();
  //const { eventTypes, setEventTypes } = useMember();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    console.log("EventTypes form - useeffect[]  :");
    if (accessToken) {

      fetchEvents();
      console.log("EventTypes form - useeffect[] Fetchevents :");
      memberProfileFetch();
      console.log("EventTypes form - useeffect[] Memberprofile :");
    }

  }, [accessToken]);

  const handleLogout = () => {
    signOut();
    navigate('/');
  };

  const [dataFields, setDataFields] = useState([]);

  const fetchEvents = async () => {
    console.log("Token value E", accessToken);
    let response, data;
    try {
      const { response, data } = await fetchEventTypes(accessToken);


      if (response.ok) {
        //const data = await response.json();
        setDataFields(data);
        setEventTypes(data);
        console.log("Fetch Event types data :", data, response, eventTypes);
      }
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Fetch events failed');
        handleLogout(); // Logout user
      }

    } catch (error) {
      console.error("Error fetching event types :", error);
      signOut();
      navigate('/');
    }
  };

  const memberProfileFetch = async () => {
    console.log("Token value M", accessToken);
    let response, data;
    try {
      //const token = "your-jwt-token-here"; // Replace with your actual JWT token
      //const { response, data } = await memberProfile(accessToken);

      //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
      const response = await fetch(`${API_URL}/gquery`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-cmdfw-jwt-token': `${accessToken}`,
        },
        body: JSON.stringify({
          query: `
                      query {
                        memProfile {
                          primary {
                            memberId
                            memberType
                            firstName
                            lastName
                            fullName
                            mobileNumber
                            email
                          },
                          spouse {
                                memberId
                                memberType
                                firstName
                                lastName
                                fullName
                                mobileNumber
                                email
                                status
                        },
                          children {
                              memberId
                              memberType
                              firstName
                              lastName
                              fullName
                              gender
                              mobileNumber
                              email
                          }
                          login {
                              showWelcome
                              memberStatus
                          }
                          houseHold {
                              householdId
                              streetAddress
                              city
                              state
                              postalCode
                          }
                          menus {
                              menuId
                              text
                              uri
                              desc
                              displayOrder
                              children {
                                  menuId
                                  text
                                  uri
                                  desc
                                  displayOrder
                              }
                          }                           
                        }
                      }
                    `,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        data.data.memProfile.spouse = data.data.memProfile.spouse || {firstName: '', lastName: '', mobileNumber: '', email: ''};
        setMemberProfile(data.data.memProfile);
        setPersonName(data.data.memProfile.primary.firstName);

        console.log("Member Profile :", data, response);
        console.log("Member Profile data :", memberProfile);
        console.log("Person Name in EventTypes: ", data.data.memProfile.primary.firstName, data.data.memProfile.login.showWelcome);
        if (data.data.memProfile.login.showWelcome === "true") {
          console.log("Show welcome screen :");
          navigate('/HouseholdMembers');
        }
      } else {
        if (response.status === 403) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'OTP expired');
          handleLogout(); // Logout user
        } else {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Member Profile fetch failed');
          }
        }
      }
    } catch (error) {
      console.error("Error fetching Member Profile :", error);
      signOut();
      navigate('/');
    }
  };

  const navy = '#1A3A6B';
  const pageBg = '#f8f7f2';

  const topEvents = dataFields.filter((d) => d.parentEventTypeId === null);

  return (
    <Box sx={{ bgcolor: pageBg, minHeight: '100vh', pb: 6 }}>

      {/* Page header banner */}
      <Box sx={{ bgcolor: navy, px: { xs: 2, md: 5 }, py: 2.5, mb: 4 }}>
        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '1.2rem', fontFamily: 'Georgia, serif', letterSpacing: 0.5 }}>
          CMDFW Registration System
        </Typography>
        <Typography sx={{ color: '#c8d4e8', fontSize: '0.85rem', mt: 0.5 }}>
          Select an event below to register
        </Typography>
      </Box>

      <Box sx={{ px: { xs: 2, md: 5 } }}>
        {topEvents.length === 0 ? (
          <Typography align="center" sx={{ color: '#888', mt: 6 }}>Loading events…</Typography>
        ) : (
          <Grid container spacing={3}>
            {topEvents.map((dataField, index) => (
              <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                <FormCard
                  title={dataField.name}
                  route={dataField.route}
                  buttonName={dataField.name === 'Donation' ? 'Donate' : dataField.name === 'Banquet' ? 'Purchase' : 'Register'}
                  eventImage={dataField.imagePath}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

    </Box>
  );

}
